// extracted by mini-css-extract-plugin
module.exports = {"selectPlan":"SelectPlan_selectPlan__2aD50","strong":"SelectPlan_strong__2OED7","planDescriptionCard":"SelectPlan_planDescriptionCard__1bVyT"};